const styles = [
  "color: #005fff; font-size: 64px;",
  "color: #ffc300; font-size: 64px;",
  "color: #ff0000; font-size: 64px;",
  "color: #00aa2d; font-size: 64px;",
  "color: #ff0000; font-size: 64px;",
  "color: #005fff; font-size: 64px;",
  "color: #00aa2d; font-size: 64px;",
  "color: #ffc300; font-size: 64px;",
  "color: #ff8c00; font-size: 64px;",
];

console.log("%cL%ci%cT%c!%cM%cU%cS%cI%cC", ...styles);

console.log(
  `
%cDAMチャンネルをご覧のみなさん%c
ソースコードを見てしまうようなメンバーのみなさん、
LiT!MUSICの開発に参加してみませんか？
→ https://github.com/lit-kansai-members/music/
`,
  "text-decoration: line-through; font-size: 16px;",
  "font-size: 16px;"
);
